// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery address was reset because the customer was changed. Please reselect it.`)
};

const en_us2_delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery address was reset because the customer was changed. Please reselect it.`)
};

const de_de2_delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferadresse wurde zurückgesetzt, da der Kunde geändert wurde. Bitte wählen Sie diese erneut aus.`)
};

const en_delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery address was reset because the customer was changed. Please reselect it.`)
};

const de_delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferadresse wurde zurückgesetzt, da der Kunde geändert wurde. Bitte wählen Sie diese erneut aus.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2", locale)
	if (locale === "en-GB") return en_gb2_delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2(inputs)
	if (locale === "en-US") return en_us2_delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2(inputs)
	if (locale === "de-DE") return de_de2_delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2(inputs)
	if (locale === "en") return en_delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2(inputs)
	return de_delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2(inputs)
};
export { delivery_address_was_reset_because_the_customer_was_changed__please_reselect_it_2 as "Delivery address was reset because the customer was changed. Please reselect it." }